// Aux Saveurs des Sapins — Theme JS

// Header scroll state
const header = document.querySelector('.site-header');
if (header) {
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// Mobile nav toggle
const navToggle = document.querySelector('.nav-toggle');
if (navToggle && header) {
  navToggle.addEventListener('click', () => header.classList.toggle('is-open'));
}

// Reveal on scroll (fade-in up)
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
}

// Parallax léger sur les motifs topographiques
const topos = document.querySelectorAll('.topo');
if (topos.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let ticking = false;
  const applyParallax = () => {
    const y = window.scrollY;
    topos.forEach((el) => {
      const rect = el.parentElement.getBoundingClientRect();
      const offset = (rect.top + y) - y;
      el.style.transform = `translate3d(0, ${offset * -0.05}px, 0)`;
    });
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(applyParallax);
      ticking = true;
    }
  }, { passive: true });
}


// Galerie produit — vignettes cliquables + navigation clavier
const initProductGallery = (gallery) => {
  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  if (!slides.length || !thumbs.length) return;

  const show = (index, focusThumb) => {
    slides.forEach((slide) => {
      const active = slide.dataset.gallerySlide === String(index);
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    thumbs.forEach((thumb) => {
      const active = thumb.dataset.galleryThumb === String(index);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active && focusThumb) thumb.focus();
    });
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb), false));
    thumb.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = (Number(thumb.dataset.galleryThumb) + step + thumbs.length) % thumbs.length;
      show(next, true);
    });
  });
};

document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);

// L'éditeur de thème re-rend la section : on réinitialise la galerie.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
});
